export default "__VITE_ASSET__BmQlds8B__"